import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { NavLink } from "react-router-dom";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { BtpData } from "../../../../../api/BtpData";
import { NetoyageData } from "../../../../../api/NetoyagaData";

const settings = {
  dots: false,
  arrows: true,
  speed: 1000,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const ProjectSection = (props) => {
  const [data, setData] = useState([]);
  useEffect(() => {
    console.log("NetoyageData: ", NetoyageData);
    console.log("BtpData: ", BtpData);
    const fusionned = NetoyageData.concat(BtpData);
    console.log("Fusionned", fusionned);
    let newProducts = [];
    let url = "nettoyage";
    fusionned.map((equipement, index) => {
      equipement.products.map((product) => {
        if (index === NetoyageData.length) {
          url = "btp";
        }
        newProducts.push({
          ...product,
          productId: equipement.id,
          route: `/others/${url}/${equipement.id}/details/${product.id}`,
        });
      });
    });
    console.log("caroussel", newProducts);
    // suffle the products
    newProducts = newProducts.sort((a, b) => 0.5 - Math.random());
    setData(newProducts);
  }, []);

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <div className={`wpo-project-area ${props.pClass}`}>
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="wpo-project-wrap project-active owl-carousel">
            <Slider style={{ height: "300px" }} {...settings}>
              {data.map((data) => (
                <div
                  className="wpo-project-item slick-slide-test"
                  key={data.id}
                >
                  <div className="wpo-project-img">
                    <img
                      src={data.image}
                      className="project-slick-image"
                      style={{
                        height: "300px",
                        width: "100%",
                      }}
                      alt=""
                    />
                    {/* <div className="left-border"></div>
                    <div className="right-border"></div> */}
                  </div>
                  <div className="wpo-project-text">
                    <h2>
                      <NavLink onClick={ClickHandler} to={data.route}>
                        {data.name}
                      </NavLink>
                    </h2>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectSection;
